import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ReturnedItemsListDetail } from 'modules/order/pages';
import _ from 'lodash';

const ReturnedItemsListTemplate = ({
	viewStore,
	viewStore: {
		loading,
		listStore,
		tableData,
		queryUtility,
		noDataItem,
		showActions,
		pdfURLReturn,
		onExpandChange,
		isExpand,
		actions,
		change,
	},
	data,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="k-grid__header--sml spc--top--sml">
			<BaasicTable
				{...{
					listStore,
					data,
					tableData,
					queryUtility,
					viewStore,
					isExpand,
					noDataItem,
					actions,
					detailComponent: ReturnedItemsListDetail,
					showActions,
					change,
				}}
				actions={viewStore}
				expandChange={onExpandChange}
				rowRender={CustomRowRender} // Expand button is visible only if return shipment has returned items.
			/>
			<iframe id="pdf-print-return" name="pdf-print-return" src={pdfURLReturn} style={{ display: 'none' }}></iframe>
		</section>
	);
};

function CustomRowRender(trElement, { dataItem }) {
	let className = '';
	if (_.has(dataItem, 'returnedItems') && dataItem.returnedItems.length > 0) {
		className = trElement.props.className;
	} else {
		className = 'not-expandable ' + trElement.props.className;
	}
	return <tr className={className}>{trElement.props.children}</tr>;
}

export default defaultTemplate(ReturnedItemsListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ReturnedItemsListTemplate.jsx